"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameOption = void 0;
var GameOption;
(function (GameOption) {
    // interface options
    GameOption["RightClickCMDSend"] = "rightClickCMDSend";
    GameOption["AutoAttack"] = "autoAttack";
    GameOption["AutoJoin"] = "autoJoin";
    GameOption["DontAttackGreys"] = "dontAttackGreys";
    GameOption["HideLobbyWhilePlaying"] = "hideLobbyWhileInGame";
    GameOption["LockWindows"] = "lockWindows";
    GameOption["SuppressZeroDamage"] = "suppressZeroDamageMessage";
    GameOption["SuppressOutgoingDoT"] = "suppressOutgoingDoTDamage";
    GameOption["NoItemAnimations"] = "noItemAnimations";
    GameOption["EnterToggleCMD"] = "enterToggleCMD";
    GameOption["NoNPCModals"] = "noNPCModals";
    GameOption["PinLastTarget"] = "pinLastTarget";
    GameOption["DyingBorderWidth"] = "dyingBorderWidth";
    GameOption["DyingBorderPercent"] = "dyingBorderPercent";
    GameOption["ShouldSortFriendly"] = "shouldSortFriendly";
    GameOption["ShouldSortDistance"] = "shouldSortDistance";
    GameOption["ShrinkCharacterBoxes"] = "shrinkCharacterBoxes";
    GameOption["LockerTabs"] = "lockerTabs";
    GameOption["DebugUI"] = "debugUI";
    GameOption["SendBannerMessagesToChat"] = "sendBannerMessagesToChat";
    GameOption["BiggerGroundWindow"] = "biggerGroundWindow";
    GameOption["ShowHPValueInsteadOfPercent"] = "showHPValueInsteadOfPercent";
    // sound options
    GameOption["SoundBGM"] = "playBGM";
    GameOption["SoundSFX"] = "playSFX";
    GameOption["SoundNostalgia"] = "playNostalgia";
    GameOption["SoundMusicVolume"] = "volumeMusic";
    GameOption["SoundSFXVolume"] = "volumeSFX";
    // debug options
    GameOption["SpritesheetDecor"] = "spritesheetDecorUrl";
    GameOption["SpritesheetWalls"] = "spritesheetWallsUrl";
    GameOption["SpritesheetItems"] = "spritesheetItemsUrl";
    GameOption["SpritesheetCreatures"] = "spritesheetCreaturesUrl";
    GameOption["SpritesheetSwimming"] = "spritesheetSwimmingUrl";
    GameOption["SpritesheetTerrain"] = "spritesheetTerrainUrl";
    GameOption["SpritesheetEffects"] = "spritesheetEffectsUrl";
    // other options
    GameOption["OtherAutoExec"] = "otherAutoExec";
    // custom options
    GameOption["CustomCSS"] = "customCSS";
})(GameOption || (exports.GameOption = GameOption = {}));
